<template>
  <div class="indexApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading"    @resize="handleResize">
    <div class="content">
      <div class="search">
        <div class="left" @click="$router.push('citys')">
          <span>当前位置</span>
          <font>{{cityData.length <=0 ? '定位中...' : cityData.cityName}}</font>
        </div>
        <div class="right" @click="$router.push('scenic')">
          <input type="text" readonly="readonly" placeholder="按景区名称搜索"/>
          <i class="el-icon-search"></i>
        </div>
      </div>
      <div style="height:45px"></div>

      <div class="banner">
        <swiper :options="swiperOption">
          <swiper-slide class="swiper-slide" v-for="(item,i) in setAdvert">
            <a><img :src="baseUrl+item.banner"></a>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="nav">
        <a v-for="(item,i) in setMallCate">
          <div v-if="item.content == 'code'" @click="cardHref">
            <img :src="baseUrl+item.image"/>
            <p>{{item.title}}</p>
          </div>
          <div v-if="item.content != 'code'" @click="$router.push(item.types == 1 ? 'product?id='+item.id : item.content)">
            <img :src="baseUrl+item.image"/>
            <p>{{item.title}}</p>
          </div>
        </a>
        <!--<a @click="cardHref">
          <img src="~assets/images/nav6.png"/>
          <p>公园卡绑卡</p>
        </a>
        <a @click="$router.push('lock')">
          <img src="~assets/images/kjk.png"/>
          <p>共享空间</p>
        </a>
        <a @click="$router.push('luggage')">
          <img src="~assets/images/luggage.png"/>
          <p>行李快送</p>
        </a>
        <a @click="$router.push('tindex?id=0')">
          <img src="~assets/images/mmp.png"/>
          <p>景点门票</p>
        </a>
        <a @click="$router.push('counts')" v-if="setRyuser.water_id>0">
          <img src="~assets/images/nav3.png"/>
          <p>配送财务</p>
        </a>
        <a @click="$router.push('water')" v-if="setRyuser.water_id<=0">
          <img src="~assets/images/nav3.png"/>
          <p>申请配送员</p>
        </a>
        <a @click="$router.push('farm')">
          <img src="~assets/images/nav2.png"/>
          <p>一米菜园</p>
        </a>
        <a @click="$router.push('import')">
          <img src="~assets/images/ry.png"/>
          <p>预约入园</p>
        </a>
        <a @click="$router.push('noty')">
          <img src="~assets/images/nav4.png"/>
          <p>消息通知</p>
        </a>
        <a @click="$router.push('lhall')">
          <img src="~assets/images/nav3.png"/>
          <p>订单大厅</p>
        </a>
        <a @click="storeCode">
          <img src="~assets/images/nav1.png"/>
          <p>云仓库</p>
        </a>
        <a @click="$router.push('tickle')">
          <img src="~assets/images/pzsb.png"/>
          <p>拍一拍</p>
        </a>
        <a @click="$router.push('lhall')">
          <img src="~assets/images/fx.png"/>
          <p>商品分销</p>
        </a>-->
      </div>
      <div class="card commen" v-if="setCard.length > 0">
        <h2>
          <div class="ctitle">新卡上新啦</div>
        </h2>
        <ul>
          <li v-for="(item,i) in setCard" @click="toPush(item.id,'scenicPay')">
            <img class="left" src="~assets/images/card.png">
            <div class="right">
              <h3>{{item.title}}</h3>
              <div class="price">使用时间：<font>{{item.starttime}} 至 {{item.endtime}}</font></div>
              <div class="price">优惠价：
                <font class="rates"><i>￥</i>{{item.rate}}</font>
                <span>￥{{item.price}}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>


      <div class="scenic commen" v-if="setScenic.length > 0">
        <h2>
          <div class="ctitle">热门景区<a @click="$router.push('scenic?sp=1')">更多<i class="el-icon-arrow-right"></i></a></div>
        </h2>
        <ul>
          <li v-for="(item,i) in setScenic" @click="toPush(item.id,'tkdetail')">
            <div class="title">
              <img :src="baseUrl+item.img[0]" >
              <div class="conTitle">
                <span>{{item.title}}</span>
                <font>营业时间：{{item.business}}</font>
                <div class="price">门票<i><b>¥</b>{{item.rate}}</i>起 <em style="font-style:normal;float:right">距离{{item.distance}}KM</em></div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="scenic commen" v-if="setMall.length > 0">
        <h2>
          <div class="ctitle">景区商圈<a @click="$router.push('product?sp=1')">更多<i class="el-icon-arrow-right"></i></a></div>
        </h2>
        <ul>
          <li v-for="(item,i) in setMall" @click="toPush(item.id,'detail')">
            <div class="title">
              <img :src="baseUrl+item.logo" >
              <div class="conTitle">
                <span>{{item.title}}</span>
                <font>营业时间：{{item.business}}</font>
                <div class="price">星级<i>{{item.star}}</i> 月售:{{item.sale}}<em style="font-style:normal;float:right">距离{{item.distance}}KM</em></div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="none" v-if="setScenic.length <= 0 && cityData.length != 0 && setMall.length <= 0 && setCard.length <= 0">
        <p>您所在的<font>{{cityData.length <=0 ? '定位中...' : cityData.cityName}}</font>地区，暂无数据...</p>
        <a @click="$router.push('citys')">切换地区</a>
      </div>
    </div>
    <div :style="bool == 1 ? 'height:85px' :'height:65px'"></div>
    <footComponent :idx='0' :dx='bool'></footComponent>
  </div>
</template>

<script>
  import $ from 'jquery'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        swiperOption: {
          autoplay : {
            disableOnInteraction: false,
            delay: 5000
          },
          initialSlide: 0,
          speed: 1000,
          loop:true,
          grabCursor: true,
          autoHeight: true,   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true,
          observeParents: true,
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },     
        },
        isIphone:false,
        code:'',
        userData:[],
        setAdvert:[],
        setCard:[],
        setScenic:[],
        setMall:[],
        setRyuser:[],
        cityData:[],
        bool:0,
        setMallCate:[]
      };
    },
    beforeMount() {
      localStorage.removeItem('user');
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideAllNonBaseMenuItem');
        WeixinJSBridge.call('hideOptionMenu');
      });
      window.removeEventListener("resize", this.handleResize);

      //var a = {"id":8,"username":"Jersey","avatar":"https://thirdwx.qlogo.cn/mmopen/vi_32/vic5e54uG6PRibXMoMOERicduNnr8uObFxN0Y0Lnibp84aDyvzxcY0vvrFeElQfINeQDb6QyFNGaZdNJn5icsiaP9uRw/132","status1":0,"role":4,"createtime":"2020-08-26"}
      //localStorage.setItem('userjwt', JSON.stringify(a));
      //var a = {cityCode: "450100", cityName: "南宁市", expires: 1919872956000,latitude:22.78658,longitude:108.49693,key:0}
      //localStorage.setItem('cCode', JSON.stringify(a));
    },
    mounted() {
      this.beforeMount();
      window.addEventListener("resize", this.handleResize);
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/index');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        if(localStorage.getItem('cCode') == null){
          //this.getQquey();
        }else{
          var cCode = JSON.parse(localStorage.getItem('cCode'));
          if(cCode.expires <= Date.parse(new Date())){
            localStorage.removeItem('cCode');
            //this.getQquey();
          }else{
            this.cityData = cCode;
            this.getCard();
            this.getScenic();
            this.getMall();
            this.getAdvert();
            this.getMallCate();
          }
        }
      }
      /*if(localStorage.getItem('userjwt') != null){
        this.ryUser()
      }*/
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
        this.bool = (h >= 800 && this.isPhone() ? 1 : 0);
      },
      handleResize:function(e){
        if(this.curHeight < e.currentTarget.innerHeight && this.isPhone()){
          this.bool = 1;
        }else {
          if(this.curHeight >= 800 && this.curHeight == e.currentTarget.innerHeight && this.isPhone()){
            this.bool = 1;
          }else{
            this.bool = 0;
          }
        }
      },
      isPhone:function(){
        if (typeof window !== 'undefined' && window) {
            return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
        }
        return false;
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'getLocation',
              'openLocation'
            ]
          });
          wx.ready(function() {
            that.fullscreenLoading = true;
            wx.getLocation({
              type: 'wgs84',
              success: function (res) {
                $.ajax({
                  type:'post',
                  url:that.$host+'home/movies/getAddressInfo',
                  data:{
                    latitude:res.latitude,
                    longitude:res.longitude,
                  },
                  dataType:'json',
                  success:function(data){
                    var expires = Date.parse(new Date()) / 1000;
                    expires = (expires + 1800) * 1000;
                    var data = {
                      cityCode:data.data.city_code,
                      cityName:data.data.city,
                      expires:expires,
                      latitude:res.latitude,
                      longitude:res.longitude,
                      key:0
                    };
                    localStorage.setItem('cCode', JSON.stringify(data));
                    that.cityData = data;
                    that.getCard();
                    that.getScenic();
                    that.getMall();
                    that.getAdvert();
                    that.getMallCate();
                  }
                })
              }
            });
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      cardHref:function(){
        window.location.href="http://user.4008005216.com/main/code"
      },
      
      storeCode:function(){
        window.location.href="http://user.4008005216.com/main/yunstore"
      },
      ryUser:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/water/wUser',
          params:{
            id:that.userData.id
          }
        }).then(function(response){
          that.setRyuser = response.data.data
        }).catch(err=>{

        });
      },

      getAdvert:function(){
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/advert',
          //url:that.$host+'home/index/getAdvert',
          data:{
            latitude:that.cityData.latitude,
            longitude:that.cityData.longitude,
            keywords:(that.cityData.key == 1 ? that.cityData.cityName : '')
          },
          dataType:'json',
          success:function(data){
            that.setAdvert = data.data
          }
        })

      },
      getMallCate:function(){
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/mallCate',
          dataType:'json',
          success:function(data){
            that.setMallCate = data.data
          }
        })
      },
      getCard:function(e){
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/scenicCard',
          data:{
            latitude:that.cityData.latitude,
            longitude:that.cityData.longitude,
            keywords:(that.cityData.key == 1 ? that.cityData.cityName : '')
          },
          dataType:'json',
          success:function(data){
            that.setCard = data.data
          }
        })
      },

      getScenic:function(e){
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/scenicLat',
          data:{
            page:1,
            limit:8,
            latitude:that.cityData.latitude,
            longitude:that.cityData.longitude,
            keywords:(that.cityData.key == 1 ? that.cityData.cityName : '')
          },
          dataType:'json',
          success:function(data){
            that.setScenic = data.data
            that.fullscreenLoading = false;
          }
        })
      },
      getMall:function(e){
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/mallBusiness',
          data:{
            latitude:that.cityData.latitude,
            longitude:that.cityData.longitude,
            keywords:(that.cityData.key == 1 ? that.cityData.cityName : '')
          },
          dataType:'json',
          success:function(data){
            that.setMall = data.data
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data;
          //that.getQquey();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .indexApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }
  .indexApp .content{
    width:100%
  }
  .indexApp .content .search{
    position:fixed;
    width:100%;
    left:0;
    background:#ececec;
    height:45px;
    top:0;
    z-index:99
  }


  .indexApp .content .search .left{
    float:left;
    height:45px;
    width:33%;
    margin-left:3%;
    position: relative;
  }
  .indexApp .content .search .left span{
    width:40px;
    float:left;
    font-size:14px;
    color:#1C222B;
    line-height:15px;
    position: relative;
    top:50%;
    transform: translateY(-50%);
  }
  .indexApp .content .search .left span:after{
    position:absolute;
    content:'';
    width:3px;
    height:3px;
    background:#1C222B;
    border-radius:10px;
    right:0
  }
  .indexApp .content .search .left font{
    width:calc(100% - 47px);
    float:left;
    font-size:14px;
    line-height:18px;
    margin-left:7px;
    color:#666;
    position: relative;
    top:50%;
    transform: translateY(-50%);
  }
  .indexApp .content .search .right{
    float:right;
    width:57%;
    height:45px;
    margin-right:3%;
    position: relative;
  }
  .indexApp .content .search input{
    height:35px;
    width:calc(100% - 40px);
    outline:none;
    border:none;
    border-radius:40px;
    margin-top:5px;
    padding:0 10px 0 30px;
    font-size:15px
  }
  .indexApp .content .search .right i{
    position:absolute;
    top:50%;
    transform: translateY(-50%);
    left:10px;
    color:#1C222B;
    font-size:16px
  }
  .indexApp .content .banner{
    background:#fff;
  }
  .indexApp .content .banner img{
    display:block;
    width:100%
  }
  .indexApp .content .nav{
    width:100%;
    background:#fff;
    padding-bottom:15px
  }
  .indexApp .content .nav:after,.indexApp .content .commen ul li:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .indexApp .content .nav a{
    float:left;
    width:20%;
    margin-top:12px
  }
  .indexApp .content .nav a img{
    width:35px;
    display:block;
    margin:0 auto
  }
  .indexApp .content .nav a p{
    width:100%;
    text-align:center;
    font-size:14px;
    color:#1C222B;
    padding-top:5px;
  }

  .indexApp .content .commen{
    background:#fff;
    width:100%;
    margin-top:10px
  }
  .indexApp .content .commen h2{
    margin:0 auto;
    font-size:16px;
    padding:15px 0;
    border-bottom:solid 1px #f5f5f5;
  }
  .indexApp .content .commen h2 .ctitle{
    width:89%;
    margin:0 auto;
    position:relative;
    padding-left:3%;
  }
  .indexApp .content .commen h2 .ctitle:after{
    content:'';
    width: 3px;
    height: 15px;
    background: #141EF1;
    position:absolute;
    left:0px;
    top:4px;
    border-radius: 3px;
  }
  .indexApp .content .commen h2 a{
    float:right;
    font-size:14px;
    font-weight:normal;
    color:#666;
    margin-top:2px
  }
  .indexApp .content .card ul{
    padding-bottom:15px
  }
  .indexApp .content .card ul li{
    width:92%;
    margin:15px auto 0 auto;
    border-bottom:solid 1px #f5f5f5;
    padding-bottom:15px
  }
  .indexApp .content .card ul li:last-child{
    border-bottom:none
  }
  .indexApp .content .card ul li .left{
    float:left;
    width:80px;
    border-radius: 6px;
  }
  .indexApp .content .card ul li .right{
    float:left;
    width:74%;
    margin-left:3%
  }
  .indexApp .content .card ul li .right h3{
    font-size:15px
  }
  .indexApp .content .card ul li .right .price{
    color:#666;
    font-size:14px;
    padding-top:8px
  }
  .indexApp .content .card ul li .right .price font{
    color:#000;
  }
  .indexApp .content .card ul li .right .price font.rates{
    color:red;
    font-weight:bold;
    font-size:16px
  }
  .indexApp .content .card ul li .right .price font i{
    font-size:12px;
    font-style:normal;
  }
  .indexApp .content .card ul li .right .price span{
    text-decoration: line-through;
    padding-left:10px
  }

  .indexApp .content .scenic ul li{
    width:92%;
    margin:15px auto 0 auto;
    border-bottom:solid 1px #f5f5f5;
    padding-bottom:15px
  }
  .indexApp .content .scenic ul li .title{
    position:relative;
    width:100%;
  }
  .indexApp .content .scenic ul li .title img{
    float:left;
    width:30%;
    border-radius:6px;
  }
  .indexApp .content .scenic ul li .title .conTitle{
    float:left;
    width:67%;
    margin-left:3%;
  }
  .indexApp .content .scenic ul li .title .conTitle span{
    display:block;
    color:#333333;
    width:100%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing:1px;
    font-size:15px;
    font-weight: bold;
  }
  .indexApp .content .scenic li .title .conTitle font{
    display:block;
    color:#666;
    font-size:14px;
    padding:10px 0
  }
  .indexApp .content .scenic li .title .conTitle .price i{
    color: #f00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .indexApp .content .scenic li .title .conTitle .price b{
    font-size:12px;
  }

  .indexApp .content .scenic li .title .conTitle .price{
    font-size: 14px;
    font-family: PingFang SC;
    color: #666;
  }

  .indexApp .none{
    width:80%;
    margin:0 auto;
    padding-top:20%
  }
  .indexApp .none p{
    color:#333;
    font-size:15px;
    width:100%;
    text-align:center;
    margin-bottom:30px
  }
  .indexApp .none p font{
    color:#e45442;
    font-weight:bold;
    padding:0 2px
  }
  .indexApp .none a{
    display:block;
    background: #0059D6;
    height: 45px;
    border-radius: 8px;
    width:140px;
    text-align:center;
    line-height: 45px;
    color:#fff;
    margin:0 auto;
  }
</style>